export function tab($tabsClass, $contentClass) {
	const tabs = document.querySelectorAll($tabsClass + " li a");
	const tab_contents = document.querySelectorAll($contentClass);
	console.log(tabs);
	console.log(tab_contents);

	for (let i = 0; i < tabs.length; i++) {
		tabs[i].addEventListener("click", function (e) {
			e.preventDefault();
			console.log(tabs.length);

			for (let j = 0; j < tabs.length; j++) {
				tabs[j].classList.remove("_active");
			}
			for (let j = 0; j < tabs.length; j++) {
				tab_contents[j].classList.remove("_active");
			}
			tabs[i].classList.add("_active");
			tab_contents[i].classList.add("_active");
		});
	}

}
